import React from 'react';
import s from './Slide.module.css';

export default function Slide({data, modalControl, setSelected}) {

    return (
        <div className={s.wrapper}>
            <div className={s.container} onClick={()=>{modalControl(); setSelected(data)}}>
                <img src={`http://peuma-ig.com.ar/admin/${data.imagen}`} alt="Logo cliente"/>
            </div>
        </div>
    )
}
